/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForOnpremAlertChecker extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForOnpremAlertChecker");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForOnpremAlertChecker.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForOnpremAlertChecker>): BackgroundJobPayloadForOnpremAlertChecker {
        let obj = Object.assign(new BackgroundJobPayloadForOnpremAlertChecker(), model);
        BackgroundJobPayloadForOnpremAlertChecker.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForOnpremAlertChecker>): BackgroundJobPayloadForOnpremAlertChecker {
        if (!model) return null;
        return BackgroundJobPayloadForOnpremAlertChecker.newInstance(<BackgroundJobPayloadForOnpremAlertChecker> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForOnpremAlertChecker) {
        if (!obj) return;

        models.BackgroundJobPayloadForOnpremAlertChecker.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForOnpremAlertChecker): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForOnpremAlertChecker.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.threshold === undefined) {
            this.threshold = 0;
        }
        if (this.window_size === undefined) {
            this.window_size = 0;
        }
    }

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * Unique resource identifier
     */
    resource_id: string;

    /**
     * Metric to evaluate
     */
    metric_name: string;

    /**
     * Alert rule type identifier
     */
    alert_type: string;

    /**
     * Breach threshold value
     */
    threshold: number;

    /**
     * Comparison operator
     */
    operator: string;

    /**
     * Rolling window size in Seconds
     */
    window_size: number;

}
